import React from 'react'
import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'

const ImageWithPlaceholder = ({ images, index, className }) =>
  index < images.length && images[index].url ? (
    <img alt={`${index}`} src={images[index].url} className={className} />
  ) : (
    <div className={className}>
      <Icon icon={IconNames.MEDIA} iconSize={50} />
    </div>
  )

const ImageTiles = ({ images }) => (
  <div className="item-header">
    <div className="image-tiles">
      <ImageWithPlaceholder images={images} index={0} className="primary-image" />
      <ImageWithPlaceholder images={images} index={1} />
      <ImageWithPlaceholder images={images} index={2} />
    </div>
  </div>
)

export default ImageTiles
